import { jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
const InfoRow = ({ label, value }) => (_jsxs(Typography, { variant: "body2", sx: { mb: 1, wordBreak: 'break-word' }, children: [_jsxs(Typography, { component: "span", variant: "body2", sx: { fontWeight: 600 }, children: [label, ":", ' '] }), value] }));
export default InfoRow;
